import React, { useRef, useState } from 'react';
import { Camera, Loader2 } from 'lucide-react';
import { Button } from './button';

const sizeMap = {
  lg: 'w-20 h-20 text-2xl',
  xl: 'w-24 h-24 text-3xl',
  '2xl': 'w-32 h-32 text-4xl',
};

export function AvatarUpload({ src, alt, name, size = 'xl', onUpload, dataTestId = 'avatar-upload' }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      await onUpload?.(file);
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <div className="relative inline-flex group" data-testid={dataTestId}>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className={`relative ${sizeMap[size]} rounded-full overflow-hidden bg-gradient-to-br from-[#800000] to-[#c66a5d] text-white font-bold shadow-md border-4 border-white`}
      >
        {src ? (
          <img src={src} alt={alt || name || 'User avatar'} className="w-full h-full object-cover" />
        ) : (
          <span className="flex w-full h-full items-center justify-center">{(name || alt || 'U').charAt(0).toUpperCase()}</span>
        )}
        <span className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/35 transition-colors flex items-center justify-center">
          {uploading ? <Loader2 className="h-5 w-5 animate-spin text-white" /> : <Camera className="h-5 w-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />}
        </span>
      </button>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={handleSelect} data-testid={`${dataTestId}-input`} />
      <Button type="button" size="sm" variant="outline" className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-8 rounded-full px-3 text-[11px] bg-white shadow-sm border-slate-200" onClick={() => inputRef.current?.click()}>
        {uploading ? 'Uploading…' : 'Upload Photo'}
      </Button>
    </div>
  );
}
